import Collapsable from './collapsable';

export function init() {
  // Get collapsable group in page
  const collapsableGroup = document.querySelectorAll('[data-collapsable-group]');

  collapsableGroup.forEach((g) => {
    // Get collapsables in group
    const hasAutoClose = g.hasAttribute('data-auto-close');
    const collapsables = g.querySelectorAll('[data-collapsable]');

    // Iterate and initialize collapsables
    collapsables.forEach((c) => new Collapsable(c, collapsables, {
      hasAutoClose,
    }));
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/Collapsable/index.js